import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const useBeforeUnload = (message = '') => {
  const unloadRedirect = useSelector(({ global }) => global.unloadRedirect)

  const handleBeforeUnload = event => {
    if (!unloadRedirect && !window.location.pathname.includes('/thank-you')) {
      event.preventDefault()
      const dialog = document.querySelector('.needsReset')
      
      if (dialog) return
  
      event.returnValue = message
    }
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [unloadRedirect])

  useEffect(() => {
    if (unloadRedirect) {
      window.location.replace(unloadRedirect)
    }
  }, [unloadRedirect])
}

export default useBeforeUnload
